import _ from 'underscore';
import axiosInstance from '../config/axiosInstance';
import errorHandler from '../utils/errorHandler';

export const getBlogPaginated = async ({ filters, continuationToken, order, rowsPerPage }) => {
  try {
    const headers = { 'x-page-size': rowsPerPage, 'x-is-paginated': true };

    if (filters && !_.isEmpty(filters)) {
      headers['x-filters'] = JSON.stringify(filters);
    }

    if (continuationToken) {
      headers['x-continuation-token'] = continuationToken;
    }

    if (order && order.by) {
      headers['x-order'] = `${order.by} ${order.type}`;
    }

    const { data } = await axiosInstance().get('/blog', { headers });
    return data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const getBlogById = async (id) => {
  try {
    const { data } = await axiosInstance().get(`/blog/${id}`);
    return data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const createBlog = async (values) => {
  try {
    const { data } = await axiosInstance().post(`/blog`, values, { headers: { 'Content-Type': 'multipart/form-data' } });
    return data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const updateBlog = async (values, id) => {
  try {
    const { data } = await axiosInstance().put(`/blog/${id}`, values, { headers: { 'Content-Type': 'multipart/form-data' } });
    return data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const deleteBlog = async (id) => {
  try {
    const { data } = await axiosInstance().delete(`/blog/${id}`);
    return data;
  } catch (error) {
    return errorHandler(error);
  }
};
